import { render, staticRenderFns } from "./ProductInfoLibriECollane.vue?vue&type=template&id=66fe2bae&scoped=true"
import script from "./ProductInfoLibriECollane.vue?vue&type=script&lang=ts"
export * from "./ProductInfoLibriECollane.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfoLibriECollane.vue?vue&type=style&index=0&id=66fe2bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe2bae",
  null
  
)

export default component.exports